import facebookTemplate from "./facebookTemplate";
import { computerScreens } from "~src/helpers/computerScreens"
import { textContents } from "../../textcontents";


const FlatPuzzle = function (posts) {

  const firstPost = {
    name: textContents.facebook.posts.first.name,
    time: "13:45",
    code: "PO",
    message: textContents.facebook.posts.first.message,
    linkPic: "https://images.cdn.yle.fi/image/upload//w_1198,h_674,f_auto,fl_lossy,q_auto:eco/39-4716745aaa858692454.jpg",
    linkUrl: textContents.facebook.posts.first.linkUrl,
    profilePic: `${window.pakopeliPublicAssetUrl}img/facebook/solvi.jpg`,
    fake: false,
    linkHeader: textContents.facebook.posts.first.linkHeader,
    linkDesc: textContents.facebook.posts.first.linkDesc,
  } 
  
  const secondPost = {
    name: textContents.facebook.posts.second.name,
    time: "11:27",
    message: textContents.facebook.posts.second.linkMessage,
    profilePic: `${window.pakopeliPublicAssetUrl}img/facebook/seppo.jpg`,
    linkPic: `${window.pakopeliPublicAssetUrl}img/facebook/rockefeller.jpg`,
    linkUrl: textContents.facebook.posts.second.linkUrl,
    code: "SA",
    fake: true,
    linkHeader: textContents.facebook.posts.second.linkHeader,
    linkDesc: textContents.facebook.posts.second.linkDesc
  } 

  const thirdPost = {
    name: textContents.facebook.posts.third.name,
    time: "11:45",
    message: textContents.facebook.posts.third.message,
    fake: false,
    code: "TE",
    profilePic: `${window.pakopeliPublicAssetUrl}img/facebook/taru.jpg`,
    linkPic: "https://images.cdn.yle.fi/image/upload//w_1198,h_674,f_auto,fl_lossy,q_auto:eco/17-3384755fc103f4d78e.jpg",
    linkUrl: textContents.facebook.posts.third.linkUrl,
    linkHeader: textContents.facebook.posts.third.linkHeader,
    linkDesc: textContents.facebook.posts.third.linkDesc
  }
    const data = [firstPost, secondPost, thirdPost]

  if(computerScreens.bunker.availableToUse()) {
   facebookTemplate(data, "bunkerPuzzle2")
 }

  

  return null;


};

export default FlatPuzzle;
